import React from "react";
import { VariantProps } from ".";
import LoginOrEnterEmail from "./LoginOrEnterEmail";

const K = ({ mapPrice, selectedProduct, productListingView }: VariantProps) => {
  return (
    <div className="map map-override mapK">
      <LoginOrEnterEmail
        {...{
          unitOfMeasure: selectedProduct.unitOfMeasure,
          mapPrice,
          type: selectedProduct.price.minimumAdvertisedPriceProperties.type,
          itemNumber: selectedProduct.itemNumber,
          price: selectedProduct.price,
          showLoginLink:
            selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers,
          priceTextSize: "small",
          productListingView,
        }}
      />
    </div>
  );
};

export default K;
